import { Link } from "react-router-dom";
import {
  partnerWhatsappOutcomeLabel,
  partnerWhatsappStatusLabel,
  buildPartnerWhatsappDealerHealthHref,
} from "../../../constants/partnerWhatsappMonitoringConstants";
import { formatConversationDate } from "../../../utils/partnerWhatsappConversationsViewModel";

function ConversationBadge({ tone, label }) {
  return (
    <span className={`partner-whatsapp-badge partner-whatsapp-badge--${tone}`}>{label}</span>
  );
}

function outcomeTone(outcome) {
  switch (outcome) {
    case "connected":
      return "green";
    case "failed":
    case "expired":
      return "red";
    case "manual_outreach":
      return "amber";
    case "dealer_passed":
      return "slate";
    default:
      return "blue";
  }
}

function attentionLabel(item) {
  if (item.isStuck) return "Stuck";
  if (item.manualOutreachRequired) return "Manual outreach";
  return "—";
}

export default function PartnerWhatsappConversationTable({
  items = [],
  conversationsBasePath,
  dealerHealthBasePath,
}) {
  if (!items.length) {
    return null;
  }

  return (
    <div className="partner-health-table-wrap">
      <table className="partner-health-table partner-whatsapp-table">
        <thead>
          <tr>
            <th>Lead</th>
            <th>Dealer</th>
            <th>Vehicle</th>
            <th>Status</th>
            <th>Outcome</th>
            <th>Last activity</th>
            <th>Messages</th>
            <th>Attention</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.crmLeadId}>
              <td>
                <strong>{item.leadRef || item.crmLeadId}</strong>
                <div className="partner-health-table__meta">{item.buyerSummary || "Buyer"}</div>
              </td>
              <td>
                {item.dealerId && dealerHealthBasePath ? (
                  <Link
                    to={buildPartnerWhatsappDealerHealthHref(dealerHealthBasePath, {
                      search: item.dealerName || item.dealerId,
                    })}
                  >
                    {item.dealerName || "Dealer"}
                  </Link>
                ) : (
                  item.dealerName || "Dealer"
                )}
              </td>
              <td>{item.vehicleSummary || "—"}</td>
              <td>
                <ConversationBadge
                  tone="blue"
                  label={item.partnerStatusLabel || partnerWhatsappStatusLabel(item.brokerStatus)}
                />
              </td>
              <td>
                <ConversationBadge
                  tone={outcomeTone(item.outcome)}
                  label={partnerWhatsappOutcomeLabel(item.outcome)}
                />
              </td>
              <td>{formatConversationDate(item.lastActivityAt)}</td>
              <td>{item.messageCount ?? 0}</td>
              <td>
                {item.isStuck || item.manualOutreachRequired ? (
                  <ConversationBadge tone="amber" label={attentionLabel(item)} />
                ) : (
                  "—"
                )}
              </td>
              <td className="partner-health-actions">
                <Link
                  className="partner-health-action"
                  to={`${conversationsBasePath}/${encodeURIComponent(item.crmLeadId)}`}
                >
                  View details
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
